import EventHandler from '../../events/event_handler';
import ImportedFormEvents from './form_events';
import ImportedFormElements from '../constants/form_elements';

export const FormEvents = ImportedFormEvents;
export const FormElements = ImportedFormElements;
export const FormEventHandler = new EventHandler(Object.values(FormEvents));

export default FormEventHandler;
